export default __webpack_public_path__ + "static/media/alm7aseb3.3f196e17.JPG";